module.exports = __webpack_public_path__ + "img/18.80342b0d.jpg";